import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

export const YarnMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 40 40' aria-hidden='true' className={cn('size-9', className)}>
            <circle cx='19' cy='20' r='15' fill='#f3c9cf' />
            <g fill='none' stroke='#fffaf3' strokeWidth='1.8' strokeLinecap='round'>
                <path d='M6.5 16.5c7-4.2 18-4.4 25 0' />
                <path d='M5.5 22c8-4.8 19-4.8 27 0' />
                <path d='M8 28c6-3.3 16-3.3 22 0' />
                <path d='M14 6.5c-4 6.5-4 20.5 0 27' />
                <path d='M24 6.5c4 6.5 4 20.5 0 27' />
            </g>
            <path d='M31 29c3 2 5 4.5 6.5 8.5' fill='none' stroke='#a84f61' strokeWidth='1.8' strokeLinecap='round' />
        </svg>
    )
}

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
}

export const Logo: FC<LogoProps> = ({ className, tone = 'dark' }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <YarnMark />
            <span className='flex flex-col leading-none'>
                <span className={cn('font-heading text-[1.35rem] font-semibold italic tracking-tight font-soft', tone === 'dark' ? 'text-cocoa-900' : 'text-cream-50')}>
                    {siteConfig.name}
                </span>
                <span className={cn('mt-1 text-[9.5px] font-bold uppercase tracking-[0.32em]', tone === 'dark' ? 'text-blush-600' : 'text-blush-200')}>
                    {siteConfig.tagline}
                </span>
            </span>
        </span>
    )
}
